module.exports = __webpack_public_path__ + "static/media/WBNB2B_Industrial_manufacturers_global_exporters_B2B_2_Indonesia.9e060e57.png";